<template>
  <el-dialog
    title="分期费用"
    :visible.sync="visible"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @close="$emit('close')"
    width="1200px"
  >
    <div style="padding: 16px;">
      <div style="background: white; padding: 16px;">
        <el-form :model="queryParams" :inline="true">
          <el-row>
            <el-col :span="6">
            <el-form-item label="患儿姓名" prop="childName">
              <el-input type="text" v-model="queryParams.searchCond.childName" size="small" placeholder="请输入" />
            </el-form-item>
            </el-col>
            <el-col :span="6">
            <el-form-item label="患儿编号" prop="outlayId">
              <el-input type="text" v-model="queryParams.searchCond.childId" size="small" placeholder="请输入" />
            </el-form-item>
            </el-col>
            <el-col :span="12">
            <SearchButton @search="loadData" @reset="resetData" :isExpand="false">
            </SearchButton>
            </el-col>
          </el-row>
        </el-form>
        <el-table v-loading="loading" :data="tableData" style="width: 100%" @current-change="clickChange">
          <el-table-column label="选择" align="center" width="50">
            <template slot-scope="scope">
              <el-radio v-model="tableRadio" :label="scope.row"><i></i></el-radio>
            </template>
          </el-table-column>
          <el-table-column key="childId" prop="childId" label="患儿编号" width="180">
          </el-table-column>
          <el-table-column key="childName" prop="childName" label="患儿姓名" width="120">
            <template slot-scope="scope">
              <TableCellWordBreak :content="scope.row.childName">{{scope.row.childName || '-'}}</TableCellWordBreak>
            </template>
          </el-table-column>
          <el-table-column key="childName" prop="childName" label="审核时间" width="120">
            <template slot-scope="scope">
              <TableCellWordBreak :content="scope.row.apprTime">{{ parseTime(scope.row.apprTime, '{y}-{m}-{d}') }}</TableCellWordBreak>
            </template>
          </el-table-column>
          <el-table-column key="helpQuota" prop="helpQuota" label="限额/已救助/剩余金额" width="240">
            <template slot-scope="scope">
              <span>{{(scope.row.helpQuota || 0) + (scope.row.specialQuota || 0)}}</span>
              <span>/</span>
              <span>{{(scope.row.usedAmount || 0).toFixed(2)}}</span>
              <span>/</span>
              <!-- <span>{{(((scope.row.helpQuota || 0) + (scope.row.specialQuota || 0)) - (scope.row.usedAmount || 0)).toFixed(2)}}</span> -->
              <span>{{((scope.row.helpQuota || 0) - (scope.row.usedAmount || 0)).toFixed(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column key="birthday" prop="birthday" label="出生日期" width="120">
          </el-table-column>
          <el-table-column key="hospitalName" v-if="isHospital==='false'"   width="200"   label="救助医院">
            <template slot-scope="scope">
              <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
            </template>
          </el-table-column>
          <el-table-column key="afterDiseasesName" prop="afterDiseasesName" label="病种">
            <template slot-scope="scope">
              <TableCellWordBreak :content="scope.row.afterDiseasesName">{{scope.row.afterDiseasesName || '-'}}</TableCellWordBreak>
            </template>
          </el-table-column>
          <el-table-column key="curStages" prop="curStages" label="期次" width="80">
          </el-table-column>
        </el-table>
        <Pageination
          @sizeChange="handleSizeChange"
          @currentChange="handleCurrentChange"
          :currentPage="queryParams.pageNO"
          :total="total">
        </Pageination>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button :loading="btnLoading" @click="$emit('close')">取 消</el-button>
      <el-button :loading="btnLoading" type="primary" @click="saveNewOutlay">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getAngleOutlayChild, saveNewOutlayAndStages } from "@/util/api.js";
import SearchButton from "@/components/business/SearchButton";
import Pageination from "@/components/business/Pageination";
import TableCellWordBreak from "@/components/business/TableCellWordBreak"

export default {
  components: {
    TableCellWordBreak,
    SearchButton,
    Pageination
  },
  props: {
    visible: false,
  },
  data () {
    return {
      loading: false,
      btnLoading: false,
      queryParams: {
        pageNO: 1,
        pageSize: 10,
        searchCond: {}
      },
      tableData: [],
      tableRadio: {},
      total: 0,
      isHospital:'false',
    }
  },
  created() {
      this.isHospital = window.localStorage.getItem("hospAccount")
    console.log(this.isHospital)
  },
  mounted () {
    this.queryParams.pageNO = 1;
    this.loadData();
  },
  methods: {
    loadData () {
      this.loading = true;
      getAngleOutlayChild(this.queryParams).then(res => {
        if (res.msgCode == 200) {
          this.tableData = res.responseData.modelData;
          this.total = res.responseData.total;
          this.loading = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    resetData () {
      this.queryParams = {
        pageNO: 1,
        pageSize: 10,
        searchCond: {}
      };
      this.loadData()
    },
    clickChange(item) {
      this.tableRadio = item;
    },
    saveNewOutlay () {
      if (this.tableRadio.allowAngelOutlay == 0) {
        this.$message.error('该救助申请审核时间超过一年或已禁止新增费用!');
        return;
      }

      if (this.tableRadio.hospitalIsAuto == 1) {
        this.$emit('autoAdd', this.tableRadio);
      } else {
        let params = {};
        params.helpReqId = this.tableRadio.helpReqId;
        params.belongProject = 'AY1002';
        params.outlayType = 1;
        params.outlayStatus = 0;
        params.inHospitalNo = this.tableRadio.inHospitalNo;
        // 非自动对接，天使分期 默认不传入院时间
        this.btnLoading = true;
        saveNewOutlayAndStages(params).then(res => {
          this.btnLoading = false;
          if (res.msgCode == 200) {
            // this.$message.success('新增分期费用成功！');
            this.$emit('success', res.responseData);
          } else {
            this.$message.error(res.msg);
          }
        });
      }

    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNO = val
      this.loadData()
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/common/dialog.scss";
</style>



// WEBPACK FOOTER //
// src/pages/outlay/cure/CureAngleChildDialog.vue